type Props = { fill?: string };

const WorkoutIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_9384_85013)">
        <path
          d="M16 3.5H15V1.5C15 1.23478 14.8946 0.98043 14.7071 0.792893C14.5196 0.605357 14.2652 0.5 14 0.5C13.7348 0.5 13.4804 0.605357 13.2929 0.792893C13.1054 0.98043 13 1.23478 13 1.5V3.5H3V1.5C3 1.23478 2.89464 0.98043 2.70711 0.792893C2.51957 0.605357 2.26522 0.5 2 0.5C1.73478 0.5 1.48043 0.605357 1.29289 0.792893C1.10536 0.98043 1 1.23478 1 1.5V3.5H0V5.5H1V7.5C1 7.76522 1.10536 8.01957 1.29289 8.20711C1.48043 8.39464 1.73478 8.5 2 8.5C2.26522 8.5 2.51957 8.39464 2.70711 8.20711C2.89464 8.01957 3 7.76522 3 7.5V5.5H13V7.5C13 7.76522 13.1054 8.01957 13.2929 8.20711C13.4804 8.39464 13.7348 8.5 14 8.5C14.2652 8.5 14.5196 8.39464 14.7071 8.20711C14.8946 8.01957 15 7.76522 15 7.5V5.5H16V3.5Z"
          fill="#3B3F42"
        />
        <path
          d="M10.9 9.05302C10.8166 8.88602 10.688 8.74572 10.529 8.64798C10.3699 8.55025 10.1867 8.499 10 8.50001H6C5.81417 8.49993 5.63199 8.55162 5.4739 8.6493C5.31581 8.74698 5.18807 8.88678 5.105 9.05302L4.105 11.053C4.0358 11.1919 3.99986 11.3449 4 11.5V15.5H6V12.5H10V15.5H12V11.5C12.0001 11.3449 11.9642 11.1919 11.895 11.053L10.9 9.05302Z"
          fill="#3B3F42"
        />
      </g>
      <defs>
        <clipPath id="clip0_9384_85013">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WorkoutIcon;
